import React, { useState, useEffect } from "react";
import BaseModal from '../baseModal';
import { saveMute } from '../../services/stacks';
import TextField from '@mui/material/TextField';
import { stacksExplorer, stacksExplorerParam } from "../../lib/constants";

import './style.scss';

const MoreOptionsModal = ({ show, txId, authorPrincipal, close, userSettings }) => {
  const fullUrl = `${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`;
  const [showMuteOptions, setShowMuteOptions] = useState(false);
  const [reason, setReason] = useState('');
  const [muteOption, setMuteOption] = useState(null);
  const [muteTxId, setMuteTxId] = useState('');
  const [muteAuthorPrincipal, setMuteAuthorPrincipal] = useState('');

  useEffect(() => {
    // console.log('txId changed:', txId);
    setMuteTxId(txId);
  }, [txId]);

  useEffect(() => {
    // console.log('authorPrincipal changed:', authorPrincipal);
    setMuteAuthorPrincipal(authorPrincipal);
  }, [authorPrincipal]);

  const resetModalState = () => {
    setShowMuteOptions(false);
    setReason('');
    setMuteOption(null);
  };

  const handleMuteClick = (muteOption) => {
    setShowMuteOptions(true);
    setMuteOption(muteOption);
  };

  const handleConfirmMuteClick = async () => {
    try {
      let id;
      if (muteOption === 'chime') {
        id = muteTxId;
      } else if (muteOption === 'author') {
        id = muteAuthorPrincipal;
      }
      await saveMute(id, reason);
      resetModalState(); // Reset the modal state
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!show) {
      resetModalState();
    }
  }, [show]);

  return (
    <BaseModal show={show} handleClose={close}>
      <div className="broadcast-modal-tx__buttons">
        <div id="options-form-container">
          <button className="button" onClick={() => window.open(fullUrl, "_blank")}>View on Explorer</button>
          <button className="button" id="mute-chime" onClick={() => handleMuteClick('chime')}>Mute Chime </button>
          <button className="button" id="mute-author" onClick={() => handleMuteClick('author')}>Mute Author</button>
          {showMuteOptions && (
            <>
              <button className="button" onClick={handleConfirmMuteClick}>Confirm Mute</button>
              <TextField className="mute-reason" id="outlined" label="Mute Reason" variant="outlined" type="text" placeholder="Mute Reason" value={reason} inputProps={{ maxLength: 13 }} onChange={(event) => setReason(event.target.value)} />
            </>
          )}
        </div>
      </div>
    </BaseModal>
  );
};

export default MoreOptionsModal;